// Auto-generated by generate-version.js – do not edit manually
const APP_VERSION = '28.10.2026 – 13:57';
export default APP_VERSION;
